import { ENDPOINT } from '~/constants';

import { HTTPError, vestigasApi } from '~/services/kyClient';
import ToastService from '~/services/toast.service';

import { i18n, log } from '~/utils';

import {
  type InvoiceStopperRulesQueryParameters,
  type InvoiceStopperRulesResponse,
} from './types';
import { zodInvoiceStopperRulesQueryParametersSchema } from './validations';

/**
 * Fetches the invoice stopper rules used for validation during invoice processing.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Invoice/operation/get_invoice_stopper_rules_vadmin_invoice_stopper_rule_get
 */
export const fetchInvoiceStopperRules = async (
  queryParameters: InvoiceStopperRulesQueryParameters,
) => {
  try {
    const response = await vestigasApi
      .get(ENDPOINT.INVOICE_REPROCESSING.GET_STOPPER_RULES(), {
        searchParams: queryParameters,
        validate: { searchParams: zodInvoiceStopperRulesQueryParametersSchema },
      })
      .json<InvoiceStopperRulesResponse>();

    return response;
  } catch (error) {
    log.error({
      message: 'Error fetching invoice stopper rules',
      error,
    });

    let errorMessage = '';

    if (error instanceof HTTPError) {
      switch (error.response.status) {
        case 422: {
          errorMessage = i18n.t(($) => $.fetchInvoiceStopperRules.error422, {
            ns: 'data',
          });
          break;
        }

        default: {
          errorMessage = i18n.t(
            ($) => $.fetchInvoiceStopperRules.error.generic,
            { ns: 'data' },
          );
        }
      }
    }

    if (errorMessage) {
      ToastService.error(errorMessage);
    }

    // Re-throw the error to propagate it to the calling function.
    throw error;
  }
};
